
import '../styles/app.styl'

import 'babel-polyfill'

import ReactDOM from 'react-dom'
import React from 'react'
import {auto} from 'async'
import {addLocaleData} from 'react-intl'
import moment from 'moment'

import getLocaleFromUrl from './utils/getLocaleFromUrl'

import App from './App'

const locale = getLocaleFromUrl()

const getLocale = (cb) => cb(null, `${getLocaleFromUrl()}-CA`)
const render = (locale, appMessages) => {
  const rootElement = document.getElementById('app')
  ReactDOM.render(
    <App locale={locale} messages={appMessages}/>,
    rootElement
  )
}

const loadPerfInLocalEnv = (cb) => {
  if(process.env.NODE_ENV == "production") { return cb() }
  require(['react-addons-perf'], Perf => cb(null, Perf))

}

const loadIntlPolyfill = (cb) => {
  if(global.Intl) { return cb() }
  const onComplete = (intl, enjs, frjs) => cb(null)
  require([
      'intl',
      'intl/locale-data/jsonp/en.js',
      'intl/locale-data/jsonp/fr.js'], onComplete)
}

const loadTranslationFiles = ({locale}, cb) => {
  const onComplete = (reactIntlMessages, momentMessages, appMessages) => cb (null, {reactIntlMessages, momentMessages, appMessages})
  if(locale == "fr-CA"){
   require(['react-intl/locale-data/fr', 'moment/locale/fr-ca.js', '../translation/fr.json'], onComplete)
  } else {
    require(['react-intl/locale-data/en', 'moment/locale/en-ca.js', '../translation/en.json'], onComplete)  
  }
}

auto({
  locale: getLocale,
  intlPolyfill: loadIntlPolyfill,
  translationFiles: ['locale', loadTranslationFiles],
  perf: loadPerfInLocalEnv,
}, (err, {locale, intlPolyfill, translationFiles, perf}) => {
  if(err) {
    return console.error("Failed to load locales or polyfill", err)
  }
  const  {reactIntlMessages, appMessages, momentMessages} = translationFiles
  addLocaleData(reactIntlMessages)
  moment.locale(locale.toLowerCase())
  window.Perf = perf
  render(locale, appMessages)
})



/** WEBPACK FOOTER **
 ** ./app/index.jsx
 **/